import { Assign } from '@doist/icons/product-ui';
import { Box, Stack } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUIAvatar } from '../product-ui-avatar/product-ui-avatar';
import { ProductUIContextMenu } from '../product-ui-context-menu/product-ui-context-menu';
import { ProductUICursorContainer } from '../product-ui-cursor/product-ui-cursor';
import { ProductUIBasicListItem } from '../product-ui-list-item';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskAttributeButton } from '../product-ui-task-attribute-button/product-ui-task-attribute-button';
import { ProductUITaskCircle } from '../product-ui-task-circle/product-ui-task-circle';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function AssignedTasksScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="AssignedTasksScene" data-sentry-source-file="assigned-tasks.tsx">
            <ProductUISceneLayer position="bottomLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="assigned-tasks.tsx">
                <ProductUIAppWindow inlineSize={800} showSidebar sidebar={<TemplateSidebarStandard />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="board">
                                <ProductUIView.Header title={t('sequence.boardsView.title')} fullWidth={false} />

                                <ProductUIView.BoardView contentXPosition={-120} contentYPosition={135}>
                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle skeletonWidth="20" />
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                    </ProductUIView.Section>

                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.assignedTasks.inProgress')}
                                        </ProductUIView.SectionTitle>

                                        <ProductUITask variant="board">
                                            <ProductUITask.Text>
                                                {t('sequence.assignedTasks.team')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                        <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" hovered={false} />} hovered={true} hoveredSection={<ProductUITask.AttributeButtonContainer>
                                                    <Box>
                                                        <ProductUITaskAttributeButton hovered={true} size="base">
                                                            <Assign />
                                                        </ProductUITaskAttributeButton>
                                                    </Box>
                                                </ProductUITask.AttributeButtonContainer>} variant="board" contextMenu={<ContextMenu />}>
                                            <ProductUITask.Text>
                                                {t('sequence.assignedTasks.duration')}
                                            </ProductUITask.Text>
                                        </ProductUITask>
                                    </ProductUIView.Section>

                                    <ProductUIView.Section>
                                        <ProductUIView.SectionTitle>
                                            {t('sequence.assignedTasks.readyforqa')}
                                        </ProductUIView.SectionTitle>

                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                        <ProductUITask variant="board">
                                            <ProductUISkeletonText width="100" />
                                        </ProductUITask>
                                    </ProductUIView.Section>
                                </ProductUIView.BoardView>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="assigned-tasks.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
function ContextMenu() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUIContextMenu placement={{
    top: 48,
    right: 10
  }} width={170} data-sentry-element="ProductUIContextMenu" data-sentry-component="ContextMenu" data-sentry-source-file="assigned-tasks.tsx">
            <Stack gap="2" data-sentry-element="Stack" data-sentry-source-file="assigned-tasks.tsx">
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="denise" />} label={t('sequence.assignedTasks.me')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assigned-tasks.tsx" />
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="ana" />} label={t('characters.ana')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assigned-tasks.tsx" />
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="luis" />} label={t('characters.luis')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assigned-tasks.tsx" />
                <ProductUICursorContainer size="lg" data-sentry-element="ProductUICursorContainer" data-sentry-source-file="assigned-tasks.tsx">
                    <ProductUIBasicListItem hovered={true} icon={<ProductUIAvatar size={20} character="stijn" />} label={t('characters.stijn')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assigned-tasks.tsx" />
                </ProductUICursorContainer>
                <ProductUIBasicListItem icon={<ProductUIAvatar size={20} character="summer" />} label={t('characters.summer')} data-sentry-element="ProductUIBasicListItem" data-sentry-source-file="assigned-tasks.tsx" />
            </Stack>
        </ProductUIContextMenu>;
}
export { AssignedTasksScene };